import { generateRejectedTaskEmail } from '../../../../email-templates/rejectedTask';

export const handleRejectedStatus = async () => {
  const emailContent = generateRejectedTaskEmail();
  const subject = 'Tu Task no puede ser realizada';

  return { emailContent, subject };
};
